class Stage {
  constructor(opportunityId, stage, pageNumber) {
    this._opportunityId = opportunityId;
    this._stage = stage;
    this._pageNumber = pageNumber;
  }

  serialize() {
    return { ...this, '@type': 'Stage' };
  }

  static deserialize(raw) {
    return new Stage(raw._opportunityId, raw._stage, raw._pageNumber);
  }
}

export default Stage;



// WEBPACK FOOTER //
// ./src/models/Stage.js